import React from 'react';

import { DropdownSingle } from 'src/app/components/lib/dropdown';
import { FormSection } from 'src/app/components/lib/form';
import { Input } from 'src/app/components/lib/input';
import { VerticalWizardCard } from 'src/app/components/lib/wizard/card/vertical-card';

import { useBuilderContext } from '../../../builder-context';

export const pushRedirectPathOptions = [
  { label: 'Home', id: '/' },
  { label: 'Cart', id: '/cart' },
  { label: 'Account', id: '/user' },
  { label: 'Specials', id: '/specials' },
];

export const getPageNameFromPath = (path: string | undefined) => {
  const pageName = pushRedirectPathOptions.find((option) => option.id === path);
  return pageName?.label ?? '';
};

export function PushCard() {
  const [builderState, dispatch] = useBuilderContext();
  const { title, body, redirectPath } = builderState.pushConfig ?? {};

  const setPushTitle = (title: string) => dispatch({ type: 'set-push-value', payload: { key: 'title', value: title } });
  const setPushBody = (body: string) => dispatch({ type: 'set-push-value', payload: { key: 'body', value: body } });
  const setPushRedirectPath = (redirectPath: string) =>
    dispatch({ type: 'set-push-value', payload: { key: 'redirectPath', value: redirectPath } });

  return (
    <VerticalWizardCard title='Push'>
      <FormSection>
        <Input
          data-testid='push-title-input'
          label='Title:'
          labelPlacement='start'
          placeholder='Add a push title'
          required
          value={title}
          onChange={(e) => setPushTitle(e.target.value)}
        />
        <Input
          data-testid='push-body-input'
          label='Body:'
          labelPlacement='start'
          placeholder='Add push body copy'
          required
          value={body}
          onChange={(e) => setPushBody(e.target.value)}
        />
        <DropdownSingle
          automationId='push-landing-page-select'
          disableDefaultFooterContent
          helpText='Select a landing page'
          label='App landing page:'
          labelPlacement='start'
          options={pushRedirectPathOptions}
          required
          setValue={(option) => setPushRedirectPath(option.id as string)}
          value={redirectPath || ''}
        />
      </FormSection>
    </VerticalWizardCard>
  );
}
